import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import i18n from "@/core/plugins/i18n";
import router from "../../router/index";
export interface APIErrorMessages {
  error: string;
}

@Module
export default class APIErrorMessagesModule
  extends VuexModule
  implements APIErrorMessages
{
  error = "";

  /**
   * Get authentification errors
   * @returns array
   */
  get getAPIErrors() {
    return this.error;
  }

  @Mutation
  [Mutations.SET_API_ERROR_MESSAGE](error) {
    const errorCodes = {
      "500": i18n.global.t("errorCodes.500"),
      "404": i18n.global.t("errorCodes.404"),
      "409": i18n.global.t("errorCodes.409"),
      "IYZ-0001": i18n.global.t("errorCodes.UserAttributesRequired"),
      errorMsg: i18n.global.t("errorCodes.errorMsg"),
    };

    const iyzicoErrorCodes = {
      InvalidEmailAddress: i18n.global.t(
        "iyzicoErrorCodes.InvalidEmailAddress"
      ),
      InvalidIdentityNumber: i18n.global.t(
        "iyzicoErrorCodes.InvalidIdentityNumber"
      ),
      InvalidPhoneNumber: i18n.global.t("iyzicoErrorCodes.InvalidPhoneNumber"),
      InvalidAddress: i18n.global.t("iyzicoErrorCodes.InvalidAddress"),
      InvalidCity: i18n.global.t("iyzicoErrorCodes.InvalidCity"),
      InvalidCountry: i18n.global.t("iyzicoErrorCodes.InvalidCountry"),
    };

    if (error.response !== undefined && error.response.data !== undefined) {
      if (
        error.response.data.code !== undefined &&
        Object.keys(errorCodes).includes(error.response.data.code)
      ) {
        this.error = errorCodes[error.response.data.code];
        if (error.response.data.code === "IYZ-0001") {
          router.push({ name: "settings" });
        }
      } else if (
        error.response.data.errorTx !== undefined &&
        Object.keys(iyzicoErrorCodes).includes(error.response.data.errorTx)
      ) {
        this.error = iyzicoErrorCodes[error.response.data.errorTx];
      } else {
        this.error = errorCodes.errorMsg;
      }
    } else if (error.status !== undefined) {
      if (Object.keys(errorCodes).includes(error.status)) {
        this.error = errorCodes[error.status];
      } else {
        this.error = errorCodes.errorMsg;
      }
    } else {
      this.error = errorCodes.errorMsg;
    }
  }

  @Action
  [Actions.API_ERROR_MESSAGE](error) {
    this.context.commit(Mutations.SET_API_ERROR_MESSAGE, error);
  }
}
